module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat1@3x-70ff0a2d02568a8ef95445307338c8ab.jpg";